import CircularProgress from '@material-ui/core/CircularProgress';
import React, { useEffect, useState } from 'react';
import axios from 'src/utils/axios';
import { useTranslation } from 'react-i18next';
import { Grid,Dialog,DialogContent,DialogContentText,DialogTitle,DialogActions,CardContent,Button,Backdrop,Container,TableCell,FormControlLabel,TablePagination,TableContainer,Divider,Paper,Table,IconButton,Card,InputAdornment,OutlinedInput,TableHead,TableBody,TableRow } 
from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import AddBoxIcon from '@material-ui/icons/AddBox';
import { makeStyles } from '@material-ui/styles';
import Page from 'src/components/Page';
import { GiConsoleController } from 'react-icons/gi';

const useStyles = makeStyles(theme => ({
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0)'
    },
    root: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2)
    },
    cardscontent: {
      minHeight: 300
    },
    backdrop: {
      zIndex: 1500,
      color: '#fff'
    },
    tableRow: {
      '&$hover:hover': {
        backgroundColor: '#f5f5f5'
      }
    },
    tableCell: {
      '$hover:hover &': {
        color: 'black'
      }
    },
    hover: {},
    searchB: {
      flexGrow: 1,
      height: 42,
      padding: theme.spacing(0, 2),
      display: 'flex',
      alignItems: 'center'
    },
    searchIconB: {
      marginRight: theme.spacing(0),
      color: theme.palette.icon
    },
    searchInputB: {
      flexGrow: 1
    },
    searchButtonB: {
      backgroundColor: theme.palette.common.white,
      marginLeft: theme.spacing(2)
    },
  }));

function ConsumerSearch({handleClick,ConsumerPhone}) {

    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [filteredConsumers, setFilteredConsumers] = useState([]);
    const { t } = useTranslation('overview');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [loading, setLoading] = useState(false);
    const [Uyari, setUyari] = React.useState('');
    const [openWarning, setopenWarning] = React.useState(false);
    const [consumerAddresses, setConsumerAddresses] = useState([]);
    const [consumerPhones, setConsumerPhones] = useState([]);
    const classes = useStyles();
    const [consumerId, setConsumerId] = useState('');

    const consumerData = {
      consumerId: filteredConsumers.Id,
      consumerFullName: filteredConsumers.Name,
      consumerPhoneNumber: filteredConsumers.Phone,
      consumerEmail: filteredConsumers.Email
    };


    const GetConsumerForMaterialOrder = () => {
      setLoading(true);
      if((consumerId == 0 || consumerId == "") && phoneNumber.trim() === ''){
          setLoading(false);
          setUyari(t('lblPhoneValidation'));
          setopenWarning(true);
      }else{
        axios
        .get(`/GetConsumerForMaterialOrder/${name ? name.toLowerCase() : null}/${surname ? surname.toLowerCase() : null}/${consumerId ? consumerId : null}/${phoneNumber ? phoneNumber : null}`)
        .then(response => {
          setLoading(false);
          if (response.data.length > 0) {
            setFilteredConsumers(response.data[0]);
            setConsumerAddresses(response.data);
            setConsumerPhones(response.data[0].Phones[0]);
          }else{
            setFilteredConsumers([]);
            setConsumerAddresses([]);
            setConsumerPhones([]);
            const informationAlert = t('lblNoFoundConsumer');
            setUyari(informationAlert);
            setopenWarning(true);
          }
        })
        .catch(error => {
          setLoading(false);
        });
      }
     
  }
    
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = event => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const handleClose = () =>{
      setopenWarning(false);
    }

    useEffect(() => {
      setPhoneNumber(ConsumerPhone || '');
    }, [ConsumerPhone]);
  
    const handlePhoneNumber = (event) => {
      const text = event.target.value;
      setPhoneNumber(text);
    };


    return (
      <Page>
        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <Container maxWidth="xl" spacing={1}>
          <Divider />
            <Card>
            <CardContent>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={3} lg={3}>
                    <OutlinedInput
                      id="outlined-adornment"
                      fullWidth
                      placeholder='Consumer Phone'
                      value={phoneNumber}
                      onChange={(event) => handlePhoneNumber(event)}
                      required
                    >
                    </OutlinedInput>
                </Grid>
                <Grid item xs={12} sm={2} lg={2}>
                  <OutlinedInput
                    id="outlined-adornment"
                    fullWidth
                    placeholder='Consumer Name'
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={2} lg={2}>
                  <OutlinedInput
                    id="outlined-adornment"
                    fullWidth
                    placeholder='Consumer Surname'
                    value={surname}
                    onChange={(e) => setSurname(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <OutlinedInput
                    id="outlined-adornment"
                    fullWidth
                    placeholder='Consumer Id'
                    value={consumerId}
                    onChange={(e) => setConsumerId(e.target.value)}
                  />
                </Grid>
                <Grid item xs={2} sm={2} lg={2}>
                    <IconButton type="button" sx={{ p: '10px' }} aria-label="search"
                        onClick={GetConsumerForMaterialOrder}
                        >
                        <SearchIcon />
                    </IconButton>
                </Grid>
                <Grid item xs={12} sm={4} lg={4}>
                  <span>{t('lblAreaCodeInfo')}</span>
                </Grid>
              </Grid>
            </CardContent>
            <Divider />
            <CardContent>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} lg={12}>
                  <TableContainer component={Paper}>
                    <Table
                      stickyHeader
                      className={classes.table}
                      size="small"
                      aria-label="sticky table"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell />
                          <TableCell align="left">
                            {t('lblConsumerName')}
                          </TableCell>
                          <TableCell align="left">
                            {t('lblConsumerSurname')}
                          </TableCell>
                          <TableCell align="left">
                            {t('lblConsumerPhone')}
                          </TableCell>
                          <TableCell align="left">
                            {t('lblConsumerAddress')}
                          </TableCell>
                          <TableCell align="left">
                            {t('lblConsumerAddressType')}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(rowsPerPage > 0
                          ? consumerAddresses.slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          : consumerAddresses
                        ).map(row => (
                          <TableRow key={row.AddressId}>
                            <TableCell align="center">
                              <FormControlLabel
                                control={
                                  <AddBoxIcon
                                    color="primary"
                                    onClick={() => handleClick(consumerData,row)}
                                  />
                                }
                              />
                            </TableCell>
                            <TableCell align="left">
                              {filteredConsumers.Name}
                            </TableCell>
                            <TableCell align="left">
                              {filteredConsumers.Surname}
                            </TableCell>
                            <TableCell align="left">
                              {row.Phone}  
                            </TableCell>
                            <TableCell align="left">
                              {row.Address}  
                            </TableCell>
                            <TableCell align="left">
                              {row.AddressType}  
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                    <TablePagination
                      rowsPerPageOptions={[5, 10]}
                      component="div"
                      count={consumerAddresses.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onChangePage={handleChangePage}
                      onChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                  </TableContainer>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Container>
        <Dialog
            open={openWarning}
            onClose={handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title" color="primary">
              {t('lblInfo')}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                {Uyari}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setopenWarning(false)} color="primary">
                {t('lblOkey')}
              </Button>
            </DialogActions>
          </Dialog>
      </Page>
      );
};


export default ConsumerSearch;